import { render, staticRenderFns } from "./CadastroAlertInfo.vue?vue&type=template&id=c762a972&scoped=true&lang=pug&"
import script from "./CadastroAlertInfo.vue?vue&type=script&lang=js&"
export * from "./CadastroAlertInfo.vue?vue&type=script&lang=js&"
import style0 from "./CadastroAlertInfo.vue?vue&type=style&index=0&id=c762a972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c762a972",
  null
  
)

export default component.exports